import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedMethodsSection() {
  const methods = [{
    title: 'Las tarjetas de memoria (flashcards) tradicionales',
    description: 'Te enseñan palabras, pero no te preparan para el acento y la velocidad del oficial.'
  }, {
    title: 'Los videos de YouTube',
    description: 'Son útiles, pero no te dan un plan de acción para las últimas 24 horas antes de tu cita.'
  }, {
    title: 'Estudiar solo en español',
    description: 'Es un error fatal, porque tu cerebro no reconoce los sonidos en inglés en el momento de la verdad.'
  }];
  return <section className="w-full bg-white" data-id="element-40">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-43">
            ¿Por Qué Lo Que Has Intentado No Funciona?
          </h2>

          <div className="space-y-6" data-id="element-44">
            {methods.map((method, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-4 items-start p-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-45">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-46" />
                <div data-id="element-47">
                  <h3 className="font-bold text-lg text-gray-900 mb-2" data-id="element-48">
                    {method.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-49">{method.description}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}